import { render, staticRenderFns } from "./RightsSection.vue?vue&type=template&id=10f54a77&scoped=true"
import script from "./RightsSection.vue?vue&type=script&lang=js"
export * from "./RightsSection.vue?vue&type=script&lang=js"
import style0 from "./RightsSection.vue?vue&type=style&index=0&id=10f54a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f54a77",
  null
  
)

export default component.exports